import { DateTime } from 'luxon';
import TimestampLocal from '../model/Timestamp';

export function timestampToDate(timestamp?: TimestampLocal): Date | null {
  if (!timestamp) {
    return null;
  }

  // eslint-disable-next-line no-underscore-dangle
  return new Date(timestamp._seconds * 1000);
}

export function compareRegisterActivationDates(
  a: { activatedAt?: TimestampLocal; isCurrent: boolean },
  b: { activatedAt?: TimestampLocal; isCurrent: boolean },
): number {
  const aTime = timestampToDate(a.activatedAt)?.getTime() ?? Number.NEGATIVE_INFINITY;
  const bTime = timestampToDate(b.activatedAt)?.getTime() ?? Number.NEGATIVE_INFINITY;
  return aTime === bTime ? Number(b.isCurrent) - Number(a.isCurrent) : bTime - aTime;
}

export function msToTimestamp(ms: number): TimestampLocal {
  return {
    _seconds: ms / 1000,
    _nanoseconds: 0,
  };
}

export const formatEndDate = (endDate: Date | string | null | undefined) => {
  if (!endDate) {
    return 'löpande';
  }
  const dateTime =
    typeof endDate === 'string' ? DateTime.fromISO(endDate) : DateTime.fromJSDate(endDate);

  if (dateTime.diffNow().as('years') > 10) {
    return 'löpande';
  }
  return dateTime.toFormat('yyyy-MM-dd');
};
